<template>
  <a-modal
    width="960px"
    title="账户管理"
    v-model:visible="visible">
    <a-form
      ref="form"
      class="form"
      layout="inline"
      :rules="rules"
      :model="form">
      <div class="paragraph-title">
        <span>个人信息</span>
      </div>
      <a-form-item label="姓名" name="name">
        <a-input v-model:value="form.name" :disabled="dialogType === 'edit'" autocomplete="off"></a-input>
      </a-form-item>
      <a-form-item label="电话" name="mobile">
        <a-input v-model:value="form.mobile" :disabled="dialogType === 'edit'" autocomplete="off"></a-input>
      </a-form-item>
      <a-form-item label="邮箱" name="email">
        <a-input v-model:value="form.email" autocomplete="off" :disabled="dialogType === 'edit'"></a-input>
      </a-form-item>
      <div class="paragraph-title">
        <span>账号信息</span>
      </div>
      <a-form-item label="账号" name="username">
        <a-input v-model:value="form.username" :disabled="dialogType === 'edit'" autocomplete="off"></a-input>
      </a-form-item>
      <a-form-item label="密码" name="password">
        <a-input v-model:value="form.password" type="password" v-if="dialogType === 'add'" autocomplete="off"></a-input>
        <span v-else>********</span>
      </a-form-item>
      <!-- <a-form-item label="账号状态" name="status">
        <a-select style="width: 140px" v-model:value="form.status">
          <a-select-option key="1">
            启用
          </a-select-option>
          <a-select-option key="0">
            禁用
          </a-select-option>
        </a-select>
      </a-form-item> -->
      <div class="paragraph-title">
        团队信息
        <a-button @click="addToTeamRoles" type="primary">增加团队角色</a-button>
      </div>
      <div>
        <div
          class="teamMember-line"
          v-for="(tm, index) in teamRoles"
          :key="index">
          <p class="teamMember-label">团队</p>
          <a-select style="width: 200px"
            v-model:value="tm.teamId"
            :disabled="isTmr">
            <a-select-option
              v-for="item in validTeamList"
              :key="item.id"
              :disabled="item.state !== 'open'">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <p class="teamMember-label">角色</p>
          <a-select style="width: 200px"
            v-model:value="tm.roleId">
            <a-select-option
              v-for="item in validRoleList"
              :key="item.roleId">
              {{ item.roleName }}
            </a-select-option>
          </a-select>
          <a-button
            @click="deleteFromTeamRoles(tm)"
            type="danger">删除</a-button>
        </div>
      </div>
    </a-form>
    <template #footer>
      <a-button @click="handleReset" type="danger" v-if="dialogType === 'edit'">
        重置密码
      </a-button>
      <a-button key="submit" type="primary" @click="handleSubmit">
        保存
      </a-button>
    </template>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
import { addUser, updateUser, resetPassword } from '@/api/user'
import { deleteTeamMember, addTeamMember, editTeamMember } from '@/api/team'
import { addCompanyMember } from '@/api/company'

export default {
  props: {
    dialogType: {
      type: String,
      default: 'add'
    },
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    const checkPassword = async (_, value) => {
      if (this.dialogType === 'add' && !value) {
        return Promise.reject(new Error('密码不能为空'))
      } else {
        return Promise.resolve()
      }
    }
    return {
      visible: false,
      form: {
        name: '',
        mobile: '',
        email: '',
        username: '',
        password: '',
        //status: '1',
        roleId: ''
      },
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '电话不能为空', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' }
        ],
        password: [
          { validator: checkPassword, trigger: 'blur' }
        ]
      },
      teamRoles: []
    }
  },
  computed: {
    ...mapState(['currentRole', 'roleList', 'companyList', 'teamList']),
    validTeamList () {
      return this.teamList.filter(t => t.companyId === this.currentRole.companyId)
    },
    validRoleList () {
      const validRoleIds = []
      switch (this.currentRole.roleId) {
        case '7':
          validRoleIds.push(...['8', '9', '10', '11', '12'])
          break
        case '8':
          validRoleIds.push(...['9', '10', '11', '12'])
          break
        case '13':
          validRoleIds.push(...['14', '15','17','18'])
          break
        case '14':
          validRoleIds.push(...['15'])
          break
      }
      const result = this.roleList.filter(r => validRoleIds.indexOf(r.roleId) !== -1)
      return result
    },
    isTmr () {
      const tmgr = ['8', '14']
      return tmgr.indexOf(this.currentRole.roleId) !== -1
    }
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        if (this.dialogType === 'edit') {
          this.form = {
            userId: this.currentItem.userId,
            name: this.currentItem.name,
            mobile: this.currentItem.mobile,
            email: this.currentItem.email,
            username: this.currentItem.username,
            //status: this.currentItem.status,
            roleId: this.currentItem.roleId
          }
          this.teamRoles = JSON.parse(JSON.stringify(this.currentItem.teams))
        } else {
          this.form = {
            name: '',
            mobile: '',
            email: '',
            username: '',
            password: '',
            status: '1',
            roleId: ''
          }
          this.teamRoles = []
          this.addToTeamRoles()
        }
      })
    },
    addToTeamRoles () {
      console.log('add')
      const tr = {
        teamId: '',
        roleId: ''
      }
      if (this.isTmr) {
        tr.teamId = this.currentRole.teamId
      }
      this.teamRoles.push(tr)
    },
    deleteFromTeamRoles (tr) {
      const index = this.teamRoles.indexOf(tr)
      this.teamRoles.splice(index, 1)
    },
    handleSubmit () {
      this.$refs.form.validate().then(async () => {
        // for (let i = this.teamRoles.length - 1; i >= 0; i--) {
        //   const tr = this.teamRoles[i]
        //   if (!tr.teamId || !tr.roleId) {
        //     this.deleteFromTeamRoles(tr)
        //   }
        // }
        if (this.dialogType === 'add') {
          const isCompanyMgr = this.teamRoles.every((team)=>{
            return team.roleId != ''
          })
          if (!this.teamRoles.length || !isCompanyMgr) {
            this.$message.error('请配置团队角色')
            return
          }
          const res = await addUser({
            ...this.form,
            roleId: 5
          })
          const userId = res.data.data.userId
          await addCompanyMember({
            userId: userId,
            companyId: this.currentRole.companyId,
            roleId: 5
          })
          for (const tr of this.teamRoles) {
            const { teamId, roleId } = tr
            await addTeamMember({
              teamId, roleId, userId
            })
          }
        } else if (this.dialogType === 'edit') {
          //const isCompanyMgr = true
          // const isCompanyMgr = this.currentItem.companies.some(cr =>
          //   (cr.companyId === this.currentRole.companyId) &&
          // (cr.roleId === '7' || cr.roleId === '13')
          // )

          const isCompanyMgr = this.teamRoles.every((team)=>{
            return team.roleId != ''
          })
          if (!this.teamRoles.length || !isCompanyMgr) {
            this.$message.error('请配置团队角色')
            return
          }
          let roleIds = []
          this.teamRoles.forEach((team)=>{
            roleIds.push(team.roleId)
          })
          console.log(JSON.parse(JSON.stringify(this.teamRoles)))
          await editTeamMember({
            roleIds:roleIds,
            teamId:this.teamRoles[0].teamId,
            userId:this.teamRoles[0].userId,
          })


          // await updateUser({
          //   ...this.form,
          //   roleId: 5
          // })
          // for (const tr of this.teamRoles) {
          //   const { teamId, roleId } = tr
          //   if (!this.currentItem.teams.some(t =>
          //     t.teamId === teamId &&
          //     t.roleId === roleId)) {
          //     await addTeamMember({
          //       teamId, roleId, userId: this.form.userId
          //     })
          //   }
          // }
          // for (const t of this.currentItem.teams) {
          //   const { teamId, roleId } = t
          //   if (!this.teamRoles.some(tr =>
          //     tr.teamId === teamId &&
          //     tr.roleId === roleId
          //   )) {
          //     await deleteTeamMember(t.id)
          //   }
          // }

        } else {
          console.log(this.dialogType)
        }
        this.$emit('update')
        this.$message.success('操作成功')
        this.visible = false
      }).catch(() => {})
    },
    handleReset () {
      this.$confirm({
        title: '重置账号密码',
        content: '重置此账号密码？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          resetPassword(this.currentItem.username).then(() => {
            this.$message.success('已重置')
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.form {
  width: 900px; display: flex; flex-wrap: wrap;
  .paragraph-title {
    margin: 10px 0;
    width: 100%;
    display: flex;
    .ant-btn {
      margin: 0 0 0 20px;
    }
  }
  .ant-form-item {
    margin: 10px 0;
    width: 290px;
  }
  .user-ctrl {
    width: 100%; text-align: right;
  }
  .teamMember-line {
    margin-bottom: 10px;
    width: 100%; display: flex; align-items: center;
    .teamMember-label {
      margin-right: 10px;
      &::before {
        display: inline-block;
        margin-right: 4px;
        color: #ff4d4f;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
      }
    }
    .ant-select {
      margin-right: 20px;
    }
    .ant-btn {
      margin-right: 10px;
    }
  }
}
</style>
